import { render, staticRenderFns } from "./PackMarkDetailEdit.vue?vue&type=template&id=49b2183a&scoped=true&"
import script from "./PackMarkDetailEdit.vue?vue&type=script&lang=js&"
export * from "./PackMarkDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./PackMarkDetailEdit.vue?vue&type=style&index=0&id=49b2183a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b2183a",
  null
  
)

export default component.exports